import React from 'react'
import PropTypes from 'prop-types'

const MessagesOutline24 = ({ className, color, height, strokeWidth, width }) => (
   <svg width={width} height={height} viewBox="0 0 24 24">
      <g
         className={className}
         stroke={color}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}>
         <polygon
            points="1 2 23 2 23 17 13 17 6 22 6 17 1 17 1 2"
            fill="none"
            strokeMiterlimit="10"
         />
      </g>
   </svg>
)

MessagesOutline24.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

MessagesOutline24.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1px',
   width: '24px'
}

export default MessagesOutline24
